import React from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./App.css";
import "./Maintenance.css";
import MaintenancePage from "./components/MaintenancePage.jsx";

// ─── Original imports (für nach der Wartung) ────────────────────────────────
// import Navbar from "./components/navbar.jsx";
// import Heading from "./components/heading.jsx";
// import Properties from "./components/estates.jsx";
// import Services from "./components/services.jsx";
// import About from "./components/about.jsx";
// import Contact from "./components/contact.jsx";
// import Footer from "./components/footer.jsx";
// import EstateDetail from "./components/estateDetail.jsx";
// import AllEstates from "./components/allEstates.jsx";
// import LegalNotice from "./components/LegalNotice.jsx";
// import NotFound from "./components/NotFound.jsx";
// import AdminRebuild from "./components/AdminRebuild.jsx";

// ══════════════════════════════════════════════════════════════════════════════
// WARTUNGSMODUS: Um die Website wieder zu aktivieren, kommentiere
// <MaintenancePage /> aus und aktiviere den <BrowserRouter>-Block unten.
// ══════════════════════════════════════════════════════════════════════════════

function App() {
  return <MaintenancePage />;

  /* ─── Normaler Website-Inhalt (nach der Wartung wieder einkommentieren) ───
  return (
    <BrowserRouter>
      <header className="App-header">
        <Navbar />
      </header>

      <Routes>
        <Route path="/" element={
          <div className="body">
            <Heading />
            <Properties />
            <Services />
            <About />

            <Contact />
          </div>
        } />
        <Route path="/estate/:id" element={<EstateDetail />} />
        <Route path="/estates" element={<AllEstates />} />
        <Route path="/admin/rebuild" element={<AdminRebuild />} />
        <Route path="/impressum" element={<LegalNotice />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
  ─────────────────────────────────────────────────────────────────────────── */
}

export default App;
